"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterResults = filterResults;
exports.hasDateInputs = hasDateInputs;
exports.hasTextInputs = hasTextInputs;
exports.hasRangeDataInputs = hasRangeDataInputs;
exports.hasSelectMultipleInputs = hasSelectMultipleInputs;
exports.pushDateIfIsInRange = pushDateIfIsInRange;
exports.pushDataIfisInSelectMultiple = pushDataIfisInSelectMultiple;
exports.pushDataIfIsInRange = pushDataIfIsInRange;
exports.validateHasSelectInput = validateHasSelectInput;
var bc_input_file_constants_1 = require("../bc-input-file/bc-input-file-constants");
var bc_search_constants_1 = require("./bc-search-constants");
function filterResults(objectArrayItem, resultFilter) {
    return objectArrayItem.filter(function (element) { return resultFilter.includes(element); });
}
function hasDateInputs(jsDates, objectArrayItem) {
    return jsDates.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
}
function hasTextInputs(jsObjt, objectArrayItem) {
    return jsObjt.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
}
function hasRangeDataInputs(jsRangeData, objectArrayItem) {
    return jsRangeData.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
}
function hasSelectMultipleInputs(jsSelectMultiple, objectArrayItem) {
    return jsSelectMultiple.length > bc_input_file_constants_1.ZERO_NUMBER && objectArrayItem.length > bc_input_file_constants_1.ZERO_NUMBER;
}
function pushDateIfIsInRange(validateDate, minDate, Maxdate) {
    var dateValue = new Date(validateDate);
    var date1 = new Date(minDate);
    var date2 = new Date(Maxdate);
    if (dateValue >= date1 && dateValue <= date2) {
        return true;
    }
    return false;
}
function pushDataIfisInSelectMultiple(valueData, selectMultiple) {
    return selectMultiple.find(function (value) { return value == valueData; });
}
function pushDataIfIsInRange(validateData, minRangeString, maxRangeString) {
    var dataValue = Number(validateData);
    var minRange = Number(minRangeString);
    var maxRange = Number(maxRangeString);
    return dataValue >= minRange && dataValue <= maxRange;
}
function validateHasSelectInput(inputValues) {
    return (inputValues.parentElement.classList.contains("".concat(bc_search_constants_1.BcSearchConstants.SEARCH_INPUT_SELECT_CLASS)) ||
        inputValues.parentElement.classList.contains("".concat(bc_search_constants_1.BcSearchConstants.SEARCH_INPUT_SELECT_ACTIVE)) ||
        inputValues.parentElement.classList.contains("".concat(bc_search_constants_1.BcSearchConstants.SEARCH_INPUT_SELECT_V2_CLASS_COMBOBOX)));
}
